import { TRouteComponent } from './_shared/routes.types';
import { PageLoader } from '@photosi/rn-components/page-loader/PageLoader';
import { lazy, Suspense } from 'react';

const LoginScreen = lazy(() => import('src/screen/login/LoginScreen'));

export const LoginRoute: TRouteComponent = ({ route }) => {
  return (
    <Suspense fallback={<PageLoader />}>
      <LoginScreen route={route} />
    </Suspense>
  );
};
